<script>
import get from 'Utils/lodash.get';
import { isNil } from 'Utils/common';
import { marked } from 'marked';

export default {
  name: 'BaseMarkdown',
  props: {
    text: String,
    mustache: Object,
  },
  computed: {
    /**
     * Resolve mustached by passed props mustached
     * @returns {StringConstructor | module.String | *}
     */
    mustachedText() {
      let mustachedText = this.text;
      if (this.mustache) {
        const matched = mustachedText.match(/{{\s*[\w.]+\s*}}/g);
        if (matched) {
          matched.forEach((x) => {
            const varPath = x.match(/[\w.]+/)[0];
            mustachedText = mustachedText.replace(x, get(this.mustache, varPath));
          });
        }
      }
      return mustachedText;
    },
    compiledMarkdown() {
      return isNil(this.mustachedText) ? '' : marked(this.mustachedText);
    },
    imgImprovedHtml() {
      return this.compiledMarkdown.replace(/<img(.*?)(\/)?>/gi, '<BaseImage$1/>');
    },
  },
  render(h) {
    return h({ template: `<div>${this.imgImprovedHtml}</div>` });
  },
};
</script>
